import { useSelector } from 'react-redux';
import Global from '../../../../../../store/global-selectors';
import { AddOns } from '../../../../../../constants/add-ons';
import { ActivationTiming } from '../../manage-subscription-drawer/constants';
import { LegacyAddOnsToPreserveThroughMigration } from '../constants';

/**
 * These are known addOns that exist in our billing provider's system. We can act on them.
 * @constant
 */
const AddOnsThatCouldBeRemoved = Object.values(AddOns);

const removeAddOnsFilter = (addOn) =>
  !LegacyAddOnsToPreserveThroughMigration.includes(addOn.code) && // never deactivate these AddOns
  AddOnsThatCouldBeRemoved.includes(addOn.code) &&
  addOn.isActive && // only active ones need removal
  !addOn.isIncludedInPlan; // is a Feature on the current plan

/**
 * Parse the full AddOn object down to the changePlan's AddOn contract
 * @param {object} addOn
 * @returns {object}
 */
const createAddOnToRemove = (addOn) => ({
  code: addOn.code,
  quantity: 0,
  activationTiming: ActivationTiming.END_OF_BILLING_CYCLE,
});

/**
 * Returns the seller's current AddOns that should be removed during the changePlan process
 * @returns {object[]}
 */
export const useGetAddOnsToRemove = () => {
  const { marketplaceAddOns } = useSelector(Global.selectSellerSubscriptionPlanInfo);
  const addOnCodesToRemove = marketplaceAddOns.filter(removeAddOnsFilter).map(createAddOnToRemove);

  return addOnCodesToRemove;
};
